import React, { useEffect, useRef, useState } from "react";

import ritikaImage from "../../assets/About/about-01.png";
import prasoonImage from "../../assets/images/Team/prasoon.webp";
import logoImage from "../../assets/images/logo/logo.png";

const C = {
  deepRed: "#A10F1A",
  gold: "#C79A3B",
  cream: "#F3EEE4",
  darkGold: "#8C6A24",
  richBrown: "#5A3A1A",
  black: "#1A1A1A",
};

const partnerData = [
 
  {
    image: ritikaImage,
    role: "Managing Partner & Litigation Head",
    name: "Ms. Ritika Gautam",
    bio: "The driving force behind R & P Partners, Ritika is known for her unwavering commitment to protecting and advancing client interests. She possesses extensive experience in handling Criminal, Matrimonial and various other legal disputes. She regularly appears before the Supreme Court of India, various High Courts, Tribunals, Commissions and District Courts across Delhi NCR, providing strategic legal solutions and dedicated representation to her clients.",
    tags: [],
  },
   {
    image: prasoonImage,
    role: "Founder Partner & Litigation Strategist",
    name: "Mr. K. Prasoon Ranjan",
    bio: "With extensive experience in litigation and dispute resolution, Mr. K. Prasoon Ranjan specializes in handling a wide range of legal matters across various sectors. His areas of practice include criminal, civil and other legal disputes. He is committed to delivering practical legal solutions and effective representation tailored to the needs of each client.",
    tags: [],
  },
];

const stats = [
  { num: "Expert", label: "Legal Advisory Services" },
  { num: "Multi-Court", label: "Presence Across India" },
  { num: "Pan-Industry", label: "Client Representation" },
];

const Tag = ({ label }) => (
  <span
    style={{
      fontSize: "10px",
      padding: "3px 9px",
      borderRadius: "999px",
      border: "1px solid rgba(140,106,36,0.22)",
      background: "rgba(199,154,59,0.07)",
      color: C.darkGold,
      fontWeight: 500,
      whiteSpace: "nowrap",
    }}
  >
    {label}
  </span>
);

const TeamSection = () => {
  const wrapRef = useRef(null);
  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined" ? window.innerWidth <= 768 : false
  );

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const el = wrapRef.current;
    if (!el) return;
    el.style.opacity = "0";
    el.style.transform = "translateY(20px)";
    const timer = setTimeout(() => {
      el.style.transition = "all 0.8s ease";
      el.style.opacity = "1";
      el.style.transform = "translateY(0)";
    }, 100);
    return () => clearTimeout(timer);
  }, []);

  return (
    <section
      style={{
        width: "100%",
        minHeight: "100vh",
        background: C.cream,
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <div
        ref={wrapRef}
        style={{
          display: "flex",
          flexDirection: "column",
          flex: 1,
          minHeight: "100vh",
        }}
      >

        {/* ── HEADER ── */}
        <div
          style={{
            background: C.deepRed,
            borderBottom: `4px solid ${C.gold}`,
            padding: isMobile ? "1rem 1.25rem" : "1rem 2.5rem",
            display: "flex",
            flexDirection: isMobile ? "column" : "row",
            alignItems: "center",
            justifyContent: "space-between",
            gap: "0.75rem",
            textAlign: isMobile ? "center" : "left",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              flexDirection: isMobile ? "column" : "row",
              gap: "1rem",
            }}
          >
            <div
              style={{
                width: isMobile ? 56 : 62,
                height: isMobile ? 56 : 62,
                borderRadius: 10,
                overflow: "hidden",
                background: "#fff",
                border: `2px solid ${C.gold}`,
                flexShrink: 0,
              }}
            >
              <img
                src={logoImage}
                alt="R & P Law Logo"
                style={{ width: "100%", height: "100%", objectFit: "cover" }}
              />
            </div>
            <div>
              <h2
                style={{
                  margin: 0,
                  color: "#fff",
                  fontSize: isMobile ? 20 : 24,
                  lineHeight: 1.2,
                  fontWeight: 600,
                }}
              >
                R & P Law Partners
              </h2>
              <p
                style={{
                  margin: "4px 0 0",
                  color: C.gold,
                  fontSize: 9,
                  letterSpacing: "0.25em",
                  textTransform: "uppercase",
                }}
              >
                New Delhi • Advocates & Legal Consultants
              </p>
            </div>
          </div>

          <div
            style={{
              color: "rgba(255,255,255,0.55)",
              fontSize: 9,
              letterSpacing: "0.2em",
              textTransform: "uppercase",
              lineHeight: 1.9,
              textAlign: isMobile ? "center" : "right",
            }}
          >
            Excellence • Integrity
            <br />
            Justice
          </div>
        </div>

        {/* ── OUR TEAM LABEL ── */}
        <div
          style={{
            padding: isMobile ? "0.65rem 1.25rem" : "0.65rem 2.5rem",
            borderBottom: "1px solid rgba(140,106,36,0.15)",
            display: "flex",
            alignItems: "center",
            gap: 10,
          }}
        >
          <div style={{ width: 30, height: 2, background: C.gold, borderRadius: 999 }} />
          <span
            style={{
              color: C.darkGold,
              letterSpacing: "0.3em",
              textTransform: "uppercase",
              fontSize: 10,
              fontWeight: 700,
            }}
          >
            Our Team
          </span>
        </div>

        {/* ── MAIN SPLIT: 45% image | 55% content ── */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: isMobile ? "1fr" : "45% 55%",
            flex: 1,
          }}
        >
          {/* LEFT: Full-height image */}
          <div
            style={{
              position: "relative",
              overflow: "hidden",
              background: "#C8B99A",
              height: isMobile ? 320 : "auto",
              minHeight: isMobile ? "auto" : "100%",
            }}
          >
            <img
              src={ritikaImage}
              alt="R & P Law Partners"
              style={{
                position: "absolute",
                inset: 0,
                width: "100%",
                height: "100%",
                objectFit: "contain",
                objectPosition: "top center",
                display: "block",
              }}
            />

            {/* Right-edge fade into cream on desktop */}
            {!isMobile && (
              <div
                style={{
                  position: "absolute",
                  inset: 0,
                  background:
                    "linear-gradient(to right, transparent 70%, rgba(243,238,228,0.5))",
                  pointerEvents: "none",
                }}
              />
            )}

            {/* Gold corner brackets */}
            {!isMobile && (
              <>
                <div
                  style={{
                    position: "absolute",
                    top: 20,
                    left: 20,
                    width: 30,
                    height: 30,
                    borderTop: "2px solid rgba(199,154,59,0.55)",
                    borderLeft: "2px solid rgba(199,154,59,0.55)",
                  }}
                />
                <div
                  style={{
                    position: "absolute",
                    bottom: 20,
                    left: 20,
                    width: 30,
                    height: 30,
                    borderBottom: "2px solid rgba(199,154,59,0.55)",
                    borderLeft: "2px solid rgba(199,154,59,0.55)",
                  }}
                />
              </>
            )}
          </div>

          {/* RIGHT: Both partners stacked */}
          <div style={{ display: "flex", flexDirection: "column" }}>
            {partnerData.map((partner, index) => (
              <div
                key={partner.name}
                style={{
                  flex: 1,
                  padding: isMobile ? "1.75rem 1.25rem" : "2rem 2.5rem",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  position: "relative",
                  borderBottom:
                    index === 0 ? "1px solid rgba(140,106,36,0.13)" : "none",
                  transition: "background 0.3s",
                  cursor: "default",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = "#EDE4D4";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = "transparent";
                }}
              >
                {/* Watermark number */}
                <div
                  style={{
                    position: "absolute",
                    top: 14,
                    right: 18,
                    fontSize: 52,
                    fontWeight: 900,
                    color: "rgba(161,15,26,0.05)",
                    lineHeight: 1,
                    userSelect: "none",
                  }}
                >
                  0{index + 1}
                </div>

                <p
                  style={{
                    margin: 0,
                    color: C.darkGold,
                    letterSpacing: "0.2em",
                    fontSize: isMobile ? 9 : 9.5,
                    fontWeight: 700,
                    textTransform: "uppercase",
                  }}
                >
                  {partner.role}
                </p>

                <h3
                  style={{
                    margin: "5px 0 0",
                    fontSize: isMobile ? 18 : 19,
                    color: C.black,
                    lineHeight: 1.25,
                    fontWeight: 600,
                  }}
                >
                  {partner.name}
                </h3>

                {/* Gold divider */}
                <div
                  style={{
                    width: 24,
                    height: 2,
                    borderRadius: 999,
                    background: C.gold,
                    margin: "8px 0",
                  }}
                />

                <p
                  style={{
                    margin: 0,
                    color: C.richBrown,
                    lineHeight: 1.8,
                    fontSize: isMobile ? 13 : 12.5,
                    display: "-webkit-box",
                    WebkitLineClamp: 3,
                    WebkitBoxOrient: "vertical",
                    overflow: "hidden",
                  }}
                >
                  {partner.bio}
                </p>

                <div
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: 5,
                    marginTop: "0.75rem",
                  }}
                >
                  {partner.tags.map((tag) => (
                    <Tag key={tag} label={tag} />
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* ── STATS ── */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: isMobile ? "1fr" : "repeat(3, 1fr)",
            background: C.deepRed,
            borderTop: `3px solid ${C.gold}`,
          }}
        >
          {stats.map((stat, index) => (
            <div
              key={stat.label}
              style={{
                textAlign: "center",
                padding: isMobile ? "1.1rem" : "1.1rem 1rem",
                borderRight:
                  !isMobile && index !== stats.length - 1
                    ? "1px solid rgba(255,255,255,0.1)"
                    : "none",
                borderBottom:
                  isMobile && index !== stats.length - 1
                    ? "1px solid rgba(255,255,255,0.1)"
                    : "none",
              }}
            >
              <div
                style={{
                  color: C.gold,
                  fontSize: isMobile ? 16 : 17,
                  fontWeight: 700,
                  letterSpacing: "0.02em",
                }}
              >
                {stat.num}
              </div>
              <div
                style={{
                  color: "rgba(255,255,255,0.6)",
                  fontSize: 9,
                  textTransform: "uppercase",
                  letterSpacing: "0.14em",
                  marginTop: 4,
                }}
              >
                {stat.label}
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default TeamSection;